// const API_BASE_URL = import.meta.env.VITE_API_URL || "https://tempmail-api.caoyixiong6.workers.dev";
const API_BASE_URL = "https://tempmail-api.fastbytelab.workers.dev";
export interface Email {
  id: string;
  from: string;
  senderName: string;
  subject: string;
  content: string;
  created_at: number;
  read: boolean;
  isNew?: boolean;
}

export interface ApiEmail {
  id: string;
  sender: string;
  sender_name: string;
  subject: string;
  content: string;
  created_at: number;
  read: boolean;
}

export const api = {
  async generateEmailAddress(): Promise<Response> {
    const response = await fetch(`${API_BASE_URL}/api/address/generate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
      },
    });

    if (response.status === 429) {
      throw new Error('Rate limit exceeded. Please try again later.');
    }

    if (!response.ok) {
      throw new Error('Failed to generate email address');
    }

    return response;
  },

  async getEmails(address: string): Promise<Response> {
    const response = await fetch(`${API_BASE_URL}/api/emails/list`, {
      headers: {
        'X-Email-Address': address,
        'X-Content-Type-Options': 'nosniff',
      },
    });

    if (response.status === 429) {
      throw new Error('Rate limit exceeded. Please try again later.');
    }

    if (!response.ok) {
      throw new Error('Failed to fetch emails');
    }

    return response;
  },

  async deleteAllEmails(address: string): Promise<Response> {
    const response = await fetch(`${API_BASE_URL}/api/delete/emails`, {
      method: 'POST',
      headers: {
        'X-Email-Address': address,
        'X-Content-Type-Options': 'nosniff',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to delete emails');
    }

    return response;
  },
}; 